"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _BuidlhubEnsClient = _interopRequireDefault(require("../../BuidlhubEnsClient"));

var _LoadingComponent = _interopRequireDefault(require("../LoadingComponent/LoadingComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const DEFAULT_TRANSLATION = {
  cancel: 'Cancel',
  close: 'Close',
  error: 'Error',
  loading: 'Registering subscription',
  placeholder: 'Enter Email address',
  registerSuccess: "Please check confirmation email to complete subscription.",
  registerFailure: "Sorry, unable to setup subscription.",
  invalidEmailAddress: "Invalid email address",
  submit: 'Submit'
};
const DEFAULT_STYLES = {
  actionsContainer: "\n        display: flex;\n        justify-content: flex-end;\n    ",
  emailInput: "\n        width: 100%; \n        margin: 1em 0;\n        padding: 1px 2px 1px 10px;\n    "
};

class EmailComponent extends _react.default.Component {
  constructor(props) {
    super(props);
    this.buidlhub = new _BuidlhubEnsClient.default();
    const emailAddress = props.emailAddress || '';
    const translation = props.translation || {};
    this.translation = _objectSpread(_objectSpread({}, DEFAULT_TRANSLATION), translation);
    this.state = {
      loading: false,
      statusMessage: null,
      hasSubmitted: false,
      subscription: {},
      emailAddress // // FIXME: show loading state
      // hasSubmitted: true,
      // loading: true,
      // error: null,
      // statusMessage: this.translation.loading
      // FIXME: show completed state
      // hasSubmitted: true,
      // statusMessage: this.translation.registerSuccess 
      // "Sorry, unable to setup subscription.";

    };
    this.components = this.buildStyledComponents(props); // bind 'this'

    this.getClient = this.getClient.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  buildStyledComponent(props, prefix, defaultType) {
    const passedComponent = props["".concat(prefix, "Component")];
    let component = passedComponent || defaultType;
    const componentStyle = passedComponent ? null : props["".concat(prefix, "Style")] || DEFAULT_STYLES[prefix];

    if (componentStyle) {
      console.log("styling ".concat(prefix, "..."));
      component = (0, _styled.default)(component)(componentStyle);
    }

    return component;
  } // https://stackoverflow.com/questions/22573494/react-js-input-losing-focus-when-rerendering


  buildStyledComponents(props) {
    const ActionsContainer = this.buildStyledComponent(props, 'actionsContainer', 'div');
    const Cancel = this.buildStyledComponent(props, 'cancel', 'button');
    const EmailInput = this.buildStyledComponent(props, 'emailInput', 'input');
    const Form = this.buildStyledComponent(props, 'form', 'form');
    const Label = this.buildStyledComponent(props, 'label', 'label');
    const MessageContainer = this.buildStyledComponent(props, 'messageContainer', 'div');
    const Submit = this.buildStyledComponent(props, 'submit', 'submit');
    const Loading = this.props.loadingComponent || _LoadingComponent.default;
    return {
      ActionsContainer,
      Cancel,
      EmailInput,
      Form,
      Label,
      Loading,
      MessageContainer,
      Submit
    };
  }

  async getClient() {
    return Promise.resolve(this.buidlhub);
  }

  async handleCancel(event) {
    if (this.props.onCancel) {
      this.props.onCancel(event);
    }
  }

  async handleFormSubmit(event) {
    event.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({
      loading: true,
      hasSubmitted: true,
      error: null,
      statusMessage: this.translation.loading
    });
    const buidlhub = await this.getClient();
    const {
      publicAddress,
      language
    } = this.props;
    const {
      emailAddress
    } = this.state;

    try {
      const response = await buidlhub.addSubscription({
        publicAddress,
        emailAddress,
        language
      });
      const isRegistered = response.status;
      const statusMessage = isRegistered ? this.translation.registerSuccess : this.translation.registerFailure;
      this.setState({
        loading: false,
        statusMessage
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  validateForm() {
    // validate email address
    this.emailInputElem;
    const isValid = typeof this.emailInputElem.checkValidity === 'function' ? this.emailInputElem.checkValidity() : /\S+@\S+\.\S+/.test(this.emailInputElem.value);

    if (!isValid) {
      this.setState({
        hasSubmitted: true,
        loading: false,
        statusMessage: this.translation.invalidEmailAddress
      });
    }

    return isValid;
  }

  handleError(error) {
    this.setState({
      loading: false,
      statusMessage: this.translation.error + ": " + error.message
    });
  }

  handleEmailInputChange(event) {
    this.setState({
      emailAddress: event.target.value
    });
  }

  render() {
    const {
      Cancel,
      Form,
      Loading,
      MessageContainer,
      ActionsContainer,
      Submit
    } = this.components;
    let body = null;
    let formActions = null; //(<Cancel type='button' onClick={this.handleCancel}>{this.translation.close}</Cancel>);

    if (!this.state.hasSubmitted) {
      body = this._renderFormBody();
      formActions = (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(Cancel, {
        type: "button",
        onClick: this.handleCancel
      }, this.translation.cancel), (0, _core.jsx)(Submit, {
        type: "submit"
      }, this.translation.submit));
    }

    return (0, _core.jsx)(Form, {
      onSubmit: this.handleFormSubmit
    }, body, this.state.statusMessage && (0, _core.jsx)(MessageContainer, null, this.state.loading && (0, _core.jsx)(Loading, null), (0, _core.jsx)("span", {
      className: "status"
    }, this.state.statusMessage)), (0, _core.jsx)(ActionsContainer, null, formActions));
  }

  _renderFormBody() {
    const address = this.props.publicAddress;
    const className = this.props.className || 'buildhub-input-email';
    const label = this.props.label || 'Email Address';
    const name = this.props.name || 'buidlhub-input-email';
    const {
      EmailInput,
      Label
    } = this.components;
    return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(Label, {
      address: address,
      name: name
    }, label), (0, _core.jsx)(EmailInput, {
      id: name,
      name: name,
      placeholder: this.translation.placeholder,
      type: "email",
      required: true,
      value: this.state.emailAddress,
      className: className,
      onChange: this.handleEmailInputChange,
      ref: elem => this.emailInputElem = elem
    }));
  }

}

exports.default = EmailComponent;